export const getIsTouch = () => !matchMedia('(pointer:fine)').matches;
